import { ImageProps } from 'next/image';

export const storyBlokLoader = ({ src, width, height }: ImageProps): string => {
  return `${src}/m/${width || 0}x${height || 0}`;
};
